import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase, BLOOD_GROUPS } from '../lib/supabase';

export default function Home() {
  const [stats, setStats] = useState({ total: 0, available: 0, requests: 0, groups: {} });
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const [donorsRes, requestsRes] = await Promise.all([
          supabase.from('donors').select('blood_group, is_available'),
          supabase.from('blood_requests').select('id').eq('is_fulfilled', false),
        ]);
        const donors = donorsRes.data || [];
        const groups = {};
        donors.forEach(d => { groups[d.blood_group] = (groups[d.blood_group] || 0) + 1; });
        setStats({ total: donors.length, available: donors.filter(d => d.is_available).length, requests: (requestsRes.data || []).length, groups });
      } catch (e) { console.error(e); } finally { setLoading(false); }
    }
    fetchData();
  }, []);

  return (
    <div>
      {/* HERO */}
      <div className="hero">
        <div className="hero-inner">
          <div className="hero-drop">🩸</div>
          <h1>രക്തം ആവശ്യമുണ്ടോ?</h1>
          <p>തോട്ടക്കാട്ടെ രക്തദാതാക്കളെ ഉടൻ കണ്ടെത്തൂ</p>
          <div className="hero-actions">
            <Link to="/donors" className="btn btn-white btn-lg">🔍 ദാതാക്കളെ കാണൂ</Link>
            <Link to="/request" className="btn btn-hero-outline btn-lg">🆘 അടിയന്തരം</Link>
          </div>
        </div>
      </div>

      <div className="page">

        {/* STATS */}
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-number">{loading ? '…' : stats.total}</div>
            <div className="stat-label">🩸 ദാതാക്കൾ</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{color:'var(--green)'}}>{loading ? '…' : stats.available}</div>
            <div className="stat-label">✅ ലഭ്യം</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{color:'#e07d00'}}>{loading ? '…' : stats.requests}</div>
            <div className="stat-label">🆘 അഭ്യർത്ഥനകൾ</div>
          </div>
        </div>

        {/* BIG ACTION BUTTONS */}
        <div className="action-grid">
          <Link to="/register" className="action-btn action-btn-red">
            <span className="action-btn-icon">✍️</span>
            <span className="action-btn-label">ദാതാവ് ആകൂ</span>
            <span className="action-btn-sub">ഡയറക്ടറിയിൽ ചേരൂ</span>
          </Link>
          <Link to="/request" className="action-btn action-btn-dark">
            <span className="action-btn-icon">🆘</span>
            <span className="action-btn-label">രക്തം ആവശ്യം</span>
            <span className="action-btn-sub">ഇപ്പോൾ അഭ്യർത്ഥിക്കൂ</span>
          </Link>
          <Link to="/donors" className="action-btn action-btn-outline">
            <span className="action-btn-icon">👥</span>
            <span className="action-btn-label">ദാതാക്കൾ</span>
            <span className="action-btn-sub">ലിസ്റ്റ് കാണൂ</span>
          </Link>
          <Link to="/rewards" className="action-btn action-btn-gold">
            <span className="action-btn-icon">🏆</span>
            <span className="action-btn-label">റിവാർഡ്</span>
            <span className="action-btn-sub">ടോപ്പ് ദാതാക്കൾ</span>
          </Link>
        </div>

        {/* BLOOD GROUP SEARCH */}
        <div className="card" style={{marginBottom: 24}}>
          <div className="section-title" style={{marginBottom: 6}}>🩸 ഗ്രൂപ്പ് തിരഞ്ഞെടുക്കൂ</div>
          <div className="section-sub" style={{marginBottom: 16}}>ആവശ്യമുള്ള രക്ത ഗ്രൂപ്പ് ടാപ്പ് ചെയ്യൂ</div>
          <div className="blood-grid">
            {BLOOD_GROUPS.map(g => (
              <button key={g} className={`blood-btn ${selectedGroup === g ? 'active' : ''}`} onClick={() => setSelectedGroup(selectedGroup === g ? null : g)}>
                {g}
                {stats.groups[g] ? <div style={{fontSize: 10, opacity: 0.75, marginTop: 2}}>{stats.groups[g]}</div> : null}
              </button>
            ))}
          </div>
          <button className="btn btn-primary btn-full btn-lg" style={{marginTop: 12}} onClick={() => navigate(selectedGroup ? `/donors?group=${encodeURIComponent(selectedGroup)}` : '/donors')}>
            🔍 {selectedGroup ? `${selectedGroup} ദാതാക്കളെ കണ്ടെത്തൂ` : 'എല്ലാ ദാതാക്കളെയും കാണൂ'}
          </button>
        </div>

        {/* EMERGENCY BANNER */}
        <div className="alert alert-danger" style={{fontSize: 15, padding: '16px 18px'}}>
          <span style={{fontSize: 24}}>⚡</span>
          <div>
            <strong>അടിയന്തര ഘട്ടത്തിൽ:</strong><br/>
            തോട്ടക്കാട് താലൂക്ക് ആശുപത്രി: <strong>0484-000000</strong>
          </div>
        </div>

      </div>
    </div>
  );
}
